module.exports = __webpack_public_path__ + "assets/202509252035/img/alipay.6b6aea86.jpg";